import React from "react";
import { FaSearch, FaHistory, FaUsers } from "react-icons/fa";
import { PlanCard } from "../components/PlanCard";

export const InicioView = ({ setView }) => (
  <div className="animate-fade-in">
    {/* --- HERO SECTION --- */}
    <section className="relative pt-36 pb-20 lg:pt-32 lg:pb-24 bg-gradient-to-br from-blue-900 via-blue-700 to-cyan-500 overflow-hidden">
      <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
      <div className="absolute top-20 right-10 w-72 h-72 bg-cyan-400 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>

      <div className="relative z-10 max-w-[1400px] 2xl:max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center justify-between gap-6 xl:gap-10">
        {/* COLUMNA 1: Texto y Botones */}
        <div className="w-full lg:w-[40%] xl:w-[45%] text-center text-white shrink-0">
          <h1 className="text-5xl md:text-6xl xl:text-7xl font-extrabold tracking-tight mb-6 drop-shadow-md leading-tight">
            Gestión Inteligente <br /> del{" "}
            <span className="text-cyan-300">Agua Potable</span>
          </h1>
          <p className="mt-4 text-xl md:text-2xl text-blue-100 font-light leading-relaxed max-w-2xl mx-auto">
            Transparencia, eficiencia y facilidad para tu comunidad. Consulta
            tus consumos y reporta tus pagos desde cualquier lugar.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-4">
            <button
              onClick={() => setView("login")}
              className="w-[85%] sm:w-auto px-6 py-2.5 bg-white text-blue-700 font-bold rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all text-base"
            >
              Acceder al Sistema
            </button>
            <button
              onClick={() => setView("consultas")}
              className="w-[85%] sm:w-auto px-6 py-2.5 bg-transparent border-2 border-white text-white font-bold rounded-full hover:bg-white/10 transition-all text-base"
            >
              Consultar Mi Deuda
            </button>
          </div>
        </div>

        {/* LADO DERECHO: Celular y descargas agrupados (2 columnas en total) */}
        <div className="w-full lg:w-[60%] xl:w-[55%] flex flex-row items-center justify-center lg:justify-center gap-2 sm:gap-6 xl:gap-8 mt-16 lg:mt-0 shrink-0">
          {/* Imagen de la app */}
          <div className="flex items-center relative shrink-0 -ml-4 sm:ml-0">
            <img
              src="/portada.png"
              alt="App Móvil AquaGestión"
              className="w-[230px] sm:w-[280px] md:w-[300px] lg:w-[280px] xl:w-[360px] 2xl:w-[400px] object-contain drop-shadow-2xl transform hover:-translate-y-2 transition-transform duration-700"
            />
          </div>

          {/* Bloque de descarga app movil */}
          <div className="flex flex-col items-start text-left shrink-0">
            <h3 className="text-2xl sm:text-3xl lg:text-4xl 2xl:text-[2.75rem] font-extrabold tracking-tight text-white drop-shadow-md mb-3 lg:mb-4 leading-tight">
              Eleva tu <br />
              <span className="text-cyan-300">Experiencia</span> <br />
              Móvil
            </h3>
            <p className="hidden sm:block text-sm lg:text-base xl:text-lg text-blue-100 font-light max-w-[220px] lg:max-w-[260px] 2xl:max-w-[320px] mb-4 lg:mb-6">
              Lleva el control de tus consumos y pagos en la palma de tu mano
              con nuestra app.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-3 mt-1">
              <img
                src="/apple.png"
                alt="Descargar en App Store"
                className="h-10 2xl:h-12 w-auto shrink-0 object-contain cursor-pointer hover:scale-105 transition-transform drop-shadow-lg"
              />
              <a
                href="https://play.google.com/store/apps/details?id=com.juntaagua.appaguamovil&hl=es_419"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block"
              >
                <img
                  src="/android.png"
                  alt="Descargar en Google Play"
                  className="h-[76px] sm:h-[84px] 2xl:h-[96px] w-auto shrink-0 object-contain cursor-pointer hover:scale-105 transition-transform drop-shadow-lg -ml-2 lg:-ml-0"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* SVG WAVE */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg
          className="relative block w-full h-[80px] md:h-[120px]"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="fill-gray-50"
          ></path>
        </svg>
      </div>
    </section>

    {/* --- PLANES DE SUSCRIPCION --- */}
    <section className="py-12 md:py-24 bg-gray-50" id="planes">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">
            Planes de Suscripción
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base md:text-lg">
            Elige el plan que mejor se adapte a tu Junta Administradora de Agua
            Potable. Todos los planes incluyen actualizaciones gratuitas y
            portal de pagos para clientes.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          <PlanCard
            name="Básico"
            price="199"
            limit="200"
            features={[
              "Gestión de consumos y lecturas",
              "Generación de recibos historicos",
              "Acceso App Móvil para la generación de consumos",
            ]}
          />
          <PlanCard
            name="Estándar"
            price="299"
            limit="400"
            features={[
              "Todo lo del Plan Básico",
              "Reportes avanzados",
              "Soporte prioritario",
              "Acceso App Móvil para la generación de consumos",
            ]}
          />
          <PlanCard
            name="Plus"
            price="399"
            limit="600"
            features={[
              "Todo lo del Plan Estándar",
              "Módulo contable completo",
              "Balances automatizados",
              "Acceso App Móvil para la generación de consumos",
            ]}
          />
          <PlanCard
            name="Premium"
            price="599"
            limit="1000"
            features={[
              "Todo lo del Plan Plus",
              "Facturación electrónica SRI",
              "1,000+ usuarios",
              "Soporte técnico VIP",
              "Acceso App Móvil para la generación de consumos",
            ]}
          />
        </div>
      </div>
    </section>

    {/* --- SERVICES PREVIEW --- */}
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center gap-16">
        <div className="md:w-1/2">
          <span className="text-blue-600 font-bold uppercase tracking-widest text-sm">
            Servicios Digitales
          </span>
          <h2 className="text-4xl font-black text-blue-900 mt-2 mb-8 leading-tight">
            La Oficina en la Palma <br /> de tu Mano
          </h2>
          <div className="space-y-8">
            <div className="flex gap-4">
              <div className="bg-blue-100 p-4 rounded-2xl h-14 w-14 flex items-center justify-center shrink-0">
                <FaSearch className="text-blue-600 text-xl" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-lg">
                  Consulta en Tiempo Real
                </h4>
                <p className="text-gray-500 leading-relaxed">
                  Accede a tu historial de consumos y saldos pendientes al
                  instante.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <div className="bg-cyan-100 p-4 rounded-2xl h-14 w-14 flex items-center justify-center shrink-0">
                <FaHistory className="text-cyan-600 text-xl" />
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-lg">
                  Historial de Pagos
                </h4>
                <p className="text-gray-500 leading-relaxed">
                  Mantén un registro digital de todos tus comprobantes
                  validados.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 relative">
          <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-[40px] blur opacity-20 animate-pulse"></div>
          <div className="relative bg-gray-50 rounded-[40px] p-12 border border-gray-100 text-center shadow-inner">
            <FaUsers className="text-6xl text-blue-400 mx-auto mb-6" />
            <h3 className="text-2xl font-bold text-blue-900 mb-4">
              ¿Eres de la Directiva?
            </h3>
            <p className="text-gray-500 mb-8 px-6">
              Gestiona socios, medidores y finanzas con herramientas de
              analítica avanzada.
            </p>
            <button
              onClick={() => setView("login")}
              className="bg-blue-600 text-white px-10 py-4 rounded-full font-bold shadow-xl hover:bg-blue-700 transition-all transform hover:scale-105 active:scale-95"
            >
              Ir al Panel Administrativo
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
);
